import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import fi from './fi'
import sv from './sv'

Vue.use(VueI18n)

const messages = {
	en: en,
	fi: fi,
	sv: sv,
}

const i18n = new VueI18n({
	locale: 'fi',
	fallbackLocale: 'fi',
	silentTranslationWarn: true,
	messages,
})

export default i18n
